import qs from "qs";
import { LogOut } from "./Token.helper";
export const getMentorships = async () => {

    try{
        const mentorships = await fetch(`/api/mentorships`, {
            method: 'GET',
            headers: {
                'accept': '*/*'
            }
        });
        if(!mentorships.ok){
            if(mentorships.status == 401){
                LogOut();
            }
            throw new Error;
        }

        const body = await mentorships.json();

        return body;
    }catch(ex){
        console.error(ex);
        throw ex;
    }
}

export const acceptMentorship = async (iFolio) => {

    const data = {
        iFolio: iFolio
    };

    try{
        const mentorships = await fetch(`/api/mentorships/accept`, {
            method: 'POST',
            headers: {
                'accept': '*/*',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        if(!mentorships.ok){
            if(mentorships.status == 401){
                LogOut();
            }
            throw new Error;
        }

        const body = await mentorships.json();

        return body;
    }catch(ex){
        console.error(ex);
        throw ex;
    }
}

export const cancelMentorship = async (iFolio) => {

    const data = {
        iFolio: iFolio
    };

    try{
        const mentorships = await fetch(`/api/mentorships/cancel`, {
            method: 'POST',
            headers: {
                'accept': '*/*',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        if(!mentorships.ok){
            if(mentorships.status == 401){
                LogOut();
            }
            throw new Error;
        }

        const body = await mentorships.json();

        return body;
    }catch(ex){
        console.error(ex);
        throw ex;
    }
}

export const finishMentorship = async (data) => {

    try{
        const mentorships = await fetch(`/api/mentorships/finish`, {
            method: 'POST',
            headers: {
                'accept': '*/*',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        if(!mentorships.ok){
            if(mentorships.status == 401){
                LogOut();
            }
            throw new Error;
        }

        const body = await mentorships.json();

        return body;
    }catch(ex){
        console.error(ex);
        throw ex;
    }
}
